<script>
    import I18n from '@js/modules/translations';

    import {mapStore} from '@js/stores/mapStore';

    const {visible = true} = $props();

    const waymarked = $derived($mapStore.isWaymarkedTrailsEnabled);

    const LEGEND = [
        {key: 'path', color: '#f5ec07', trail: true},
        {key: 'track', color: '#ffffff', bordered: true},
        {key: 'street', color: '#ffeeaa'},
        {key: 'main_road', color: '#ffcc88'}
    ];

    let collapsed = $state(typeof window !== 'undefined' && window.innerWidth < 1024);

    const _toggle = () => {
        collapsed = !collapsed;
    };
</script>

{#if visible}
    <div class="map-type-legend"
         class:is-collapsed={collapsed}>
        <button type="button"
                class="map-type-legend-header"
                aria-expanded={!collapsed}
                onclick={_toggle}>
            <span class="map-type-legend-title">{I18n.t('js.maps.legend.title')}</span>
            <svg class="map-type-legend-arrow"
                 xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 24 24"
                 fill="currentColor"
                 aria-hidden="true">
                <path d="M7,10L12,15L17,10H7Z"/>
            </svg>
        </button>

        {#if !collapsed}
            <div class="map-type-legend-items">
                {#each LEGEND as item (item.key)}
                    <div class="map-type-legend-item">
                        <span class="map-type-legend-line"
                              class:is-dashed={item.dashed}
                              class:is-trail={item.trail && !waymarked}
                              class:is-waymarked={item.trail && waymarked}
                              class:is-bordered={item.bordered}
                              style={`--legend-color:${item.color};`}></span>
                        <span class="map-type-legend-label">
                            {I18n.t(`js.maps.legend.${item.key}`)}
                            {#if item.trail && waymarked}
                                <span class="map-type-legend-sublabel">{I18n.t('js.maps.legend.waymarked_only')}</span>
                            {/if}
                        </span>
                    </div>
                {/each}
            </div>
        {/if}
    </div>
{/if}
